import {btn_c_link, btn_li_sm, font_s_lg, font_s_md, font_s_xl, clearfix, colors} from '@xpertdox_js/xdstyle';

export default {
  clearfix: clearfix,
  fillHeightContainer: {
    position: 'relative',
    height: 'auto',
  },
  fillHeightPanel: {
    position: 'absolute',
    height: '100%',
  },
  fillHeightStaticPanel: {
    float: 'right',
  },
  // pageTitle: {
  //   fontSize: '2.5rem',
  //   color: colors.black,
  // },
  panelContainer: {
    marginBottom: '12px'
  },
  panel: {
    background: '#fff',
    borderRadius: '3px',
    padding: '12px',
    ...font_s_md,
    height: '100%',
    marginBottom: 0,
    minHeight: 165, // User details was stripping while changing instance name on home page
  },
  panelTitle: {
    margin: '0 0 15px',
    color: colors.black,
    ...font_s_lg,
  },
  subTitle: {
    ...font_s_lg,
    color: colors.black,
    margin: '0 0 5px',
    borderBottom: '1px dotted ' + colors.gray,
    paddingBottom: '5px',
  },
  descriptionTitle: {
    fill: colors.xdHighlight,
  },
  descriptionBox: {
    color: colors.darkGray,
    marginBottom: '10px',
    minHeight: '200px'
  },
  list: {
    margin: 0,
    marginBottom: 10,
    paddingLeft: '0',
    listStyle: 'none'
  },
  listItem: {
    padding: '4px 0',
    color: 'rgb(68, 84, 97)',
    fill: 'rgb(68, 84, 97)'
  },
  link: {
    ...btn_li_sm,
    ...btn_c_link.base,
    paddingLeft: 0,
    paddingRight: 0,
    // padding: '4px 0',
    // display: 'block',
  },
  linkHov: {
    ...btn_c_link.hover,
  },
  linkText: {
    display: 'inline-block',
    marginTop: '2px'
  }
}
